import React from "react";
import { WhatsAppIcon } from "./icons/WhatsAppIcon";
import { getWhatsAppUrl } from "../data/mock";

/**
 * Botão fixo WhatsApp — canto inferior direito, cor #25D366, pulso.
 */
export function WhatsAppFloat() {
  return (
    <div className="pointer-events-none fixed bottom-5 right-4 z-[100] md:bottom-8 md:right-8">
      <div className="relative flex h-12 w-12 items-center justify-center md:h-14 md:w-14">
        <span
          className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-30"
          aria-hidden
          style={{ animationDuration: "2.4s" }}
        />
        <a
          href={getWhatsAppUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="pointer-events-auto relative flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white md:h-14 md:w-14"
          aria-label="Conversar no WhatsApp"
        >
          <WhatsAppIcon className="h-7 w-7 md:h-8 md:w-8" />
        </a>
      </div>
    </div>
  );
}
